import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    FormControl,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import { LifeGraphByBurstIQIcon } from '../../assets';
import { FormLabel } from 'components';
import { styles } from './RealmInput.helper';

export const RealmInputModal = (): React.JSX.Element => {
    const [realmValue, setRealmValue] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (): void => {
        if (realmValue.trim() !== '') {
            navigate(`/?realm=${realmValue}`);
            window.location.reload();
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Enter' && realmValue.trim() !== '') {
            handleSubmit();
        }
    };

    return (
        <Grid container sx={styles.mainContainer}>
            <Grid item sx={styles.container}>
                <Grid container direction={'column'} sx={styles.formContainer}>
                    <img
                        src={LifeGraphByBurstIQIcon}
                        alt='icon'
                        style={styles.image}
                    />
                    <Typography variant='h1' sx={styles.heading}>
                        Sign in to Your Team
                    </Typography>

                    <Grid sx={styles.formLabelContainerStyles}>
                        <FormLabel
                            text={'Enter a customer name to continue'}
                            required={true}
                            condensed={true}
                        />
                    </Grid>
                    <FormControl fullWidth sx={styles.formControl}>
                        <TextField
                            value={realmValue}
                            onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ): void => setRealmValue(e.target.value)}
                            onKeyDown={handleKeyPress}
                            required
                            sx={styles.textField}
                        />
                    </FormControl>

                    <Button
                        fullWidth
                        disabled={!realmValue.trim()}
                        onClick={handleSubmit}
                        variant='contained'
                        sx={styles.button}
                    >
                        CONTINUE
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};
